module.exports = __webpack_public_path__ + "static/media/w (18).7d872d74.jpg";